/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useEffect, useState } from 'react';

import { ContentSide, LogoIcon, LogoOut, SideOptions } from './styled';

import SideButton from './SideButton';
import SideUserButton from './SideUserButton';

export default function Side({
  availableCatalogs,
  currentCatalog,
  selectCatalog,
  selectProfile,
}: {
  availableCatalogs: Array<{ id?: string | number; icon: Record<string, unknown> }>;
  currentCatalog?: { id?: string | number };
  selectCatalog: (item: Record<string, unknown>) => void;
  selectProfile: () => void;
}) {
  return (
    <>
      <ContentSide>
        <LogoOut>
          <LogoIcon />
        </LogoOut>
        <SideOptions>
          {availableCatalogs.map((item, key: number) => (
            <SideButton
              key={key}
              focusKey={`sideoption-${key + 1}`}
              item={item}
              onPress={() => selectCatalog(item)}
              onEnterPress={() => selectCatalog(item)}
              active={currentCatalog?.id === item?.id}
              first={key === 0}
              last={key === availableCatalogs.length - 1}
            />
          ))}
        </SideOptions>
        <SideUserButton
          onPress={() => selectProfile()}
          onEnterPress={() => selectProfile()}
          focusKey={`sideoption-4`}
        />
      </ContentSide>
    </>
  );
}
